import { FC, useRef } from 'react'
import styles from './Pod4ElevateSleep.module.scss'
import { Pod4ElevateSleepProps } from './types'
import { Img } from 'components/basic/Img'
import cx from 'classnames'
import { Type } from 'components/Type'
import { VideoGif } from 'components/basic/VideoGif'

const ElevationCard = ({ headElevation, img, feetElevation }: { img: string; headElevation: string; feetElevation: string }) => (
	<div className={styles.elevation}>
		<div className={styles.images}>
			<Img
				alt="Elevation card image"
				src={img}
			/>
		</div>
		<div className={styles.angles}>
			<div className={styles.angleTitle}>Head</div>
			<div className={styles.angleTitle}>Feet</div>
			<div className={styles.angleValue}>{`${headElevation}°`}</div>
			<div className={styles.angleValue}>{`${feetElevation}°`}</div>
		</div>
	</div>
)
export const Pod4ElevateSleep: FC<Pod4ElevateSleepProps> = (props) => {
	const {} = props
	const bannerContainerRef = useRef<HTMLDivElement>(null)
	const accessoriesCardsContainerRef = useRef<HTMLDivElement>(null)
	const elevationCardref = useRef<HTMLDivElement>(null)
	const sleepingCardref = useRef<HTMLDivElement>(null)

	return (
		<div className={styles.container}>
			<div
				className={styles.videoContainer}
				ref={accessoriesCardsContainerRef}
			>
				<VideoGif
					src={'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/sleeping_mode_desktop_1641_comp.mp4'}
					className={styles.video}
					loop={false}
				/>
				<VideoGif
					src={'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/sleeping_mode_mobile_1642_comp.mp4'}
					className={cx(styles.video, styles.videoMob)}
					loop={false}
				/>
				<div
					className={styles.floatingInfo}
					ref={sleepingCardref}
				>
					<Type.Eyebrow
						animateOnScroll
						className={styles.eyebrow}
					>
						Sleeping position
					</Type.Eyebrow>
					<Type.Headline3
						as={'h2'}
						animateOnScroll
						className={styles.title}
					>
						Float into deep sleep
					</Type.Headline3>
					<Type.Body1
						animateOnScroll
						className={styles.text}
					>
						This expertly-designed position evenly distributes pressure across your body to reduce back pain during sleep with a slight elevation of the head and feet.
					</Type.Body1>
					<ElevationCard
						img="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/sleeping_elevation_opaque.png"
						headElevation={'5'}
						feetElevation={'5'}
					/>
				</div>
			</div>
			<div
				className={styles.videoContainer}
				ref={bannerContainerRef}
			>
				<VideoGif
					src={'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/pod4_Elevate_1_comp.mp4'}
					className={styles.video}
				/>
				<VideoGif
					src={'https://res.cloudinary.com/eightsleep/video/upload/f_auto,q_auto/eightsleep_mob_elevate1_comp.mp4'}
					className={cx(styles.video, styles.videoMob)}
				/>
				<div
					className={styles.floatingInfo}
					ref={elevationCardref}
				>
					<Type.Eyebrow
						animateOnScroll
						className={styles.eyebrow}
					>
						Reading position
					</Type.Eyebrow>
					<Type.Headline3
						as={'h2'}
						animateOnScroll
						className={styles.title}
					>
						No more stacking pillows
					</Type.Headline3>
					<Type.Body1
						animateOnScroll
						className={styles.text}
					>
						Whether you're reading, sleeping, or simply relaxing, enjoy custom positions for ultimate comfort.{' '}
					</Type.Body1>
					<ElevationCard
						img="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/relaxing_elevation_opaque.png"
						headElevation={'30'}
						feetElevation={'15'}
					/>
				</div>
			</div>
		</div>
	)
}
